"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGlobalEvents = void 0;
var _react = require("react");
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- GlobalEvent type is generic

/**
 * Custom hook that registers global event listeners on the window object when the component mounts,
 * and removes them when the component unmounts.
 *
 * @example
 * ```typescript
 * useGlobalEvents([
 *   { name: 'click', listener: (event: MouseEvent) => console.log(event) },
 *   { name: 'keydown', listener: (event: KeyboardEvent) => console.log(event.key) },
 * ]);
 * ```
 */
const useGlobalEvents = events => {
  (0, _react.useEffect)(() => {
    const controller = new AbortController();
    const {
      signal
    } = controller;
    events.forEach(({
      name,
      listener,
      options
    }) => {
      const finalOptions = typeof options === 'object' ? {
        ...options,
        signal
      } : {
        capture: options,
        signal
      };
      window.addEventListener(name, listener, finalOptions);
    });
    return () => {
      controller.abort();
    };
  }, [events]);
};
exports.useGlobalEvents = useGlobalEvents;
